import { GridRow } from '../../../../types/types';

export const hasMorePages = (
  pageRows: GridRow[],
  totalCount: number | undefined,
  nextOffset: number
): boolean =>
  pageRows.length > 0 && totalCount !== undefined && nextOffset < totalCount;
